import { render, staticRenderFns } from "./gologin.vue?vue&type=template&id=3a810360&scoped=true&"
import script from "./gologin.vue?vue&type=script&lang=js&"
export * from "./gologin.vue?vue&type=script&lang=js&"
import style0 from "./gologin.vue?vue&type=style&index=0&id=3a810360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a810360",
  null
  
)

export default component.exports